// sourceTypeLabel — row label for a translation job when the backend has
// not produced a title yet. List rows never carry sourceUrl, so a freshly
// submitted URL job shows a generic "Link" until the worker fills `title`.
//
// `upload` is a job an admin created server-side (multipart
// POST /api/translations/upload); the browser itself only ever submits
// `url` or `firebase` (see detectSourceType in TranslatorScreen).
//
// Pure module so it is unit-testable without React / Firebase — it takes
// the `t` lookup rather than importing one.
//
// F-02: was an inline [he, en] pair chosen by an `rtl` boolean, which
// gave Armenian and Russian readers the English label. The strings live
// in @nayto/i18n now (trSourceType*), so all four languages work.

import type { TranslationSourceType } from '@nayto/types';

const LABEL_KEYS: Record<TranslationSourceType, string> = {
  url: 'trSourceTypeUrl',
  firebase: 'trSourceTypeFirebase',
  upload: 'trSourceTypeUpload',
};

export function sourceTypeLabel(
  sourceType: TranslationSourceType,
  t: (key: string) => string,
): string {
  const key = LABEL_KEYS[sourceType];
  // A value outside the union can only arrive from a newer API; show it
  // raw rather than crash.
  if (!key) return String(sourceType);
  return t(key);
}
